import { render } from "./OfferSelectProductForm.vue?vue&type=template&id=083019c6"
import script from "./OfferSelectProductForm.vue?vue&type=script&lang=js"
export * from "./OfferSelectProductForm.vue?vue&type=script&lang=js"
script.render = render

export default script